export const authorizationConstants = {
  // The error happens if the user didn't finish the confirmation step when signing up
  // In this case you need to resend the code and confirm the user
  userNotConfirmedException: 'UserNotConfirmedException',

  // The error happens when the password is reset in the Cognito console
  // In this case you need to call forgotPassword to reset the password
  passwordResetRequiredException: 'PasswordResetRequiredException',

  // The error happens when the incorrect password is provided
  notAuthorizedException: 'NotAuthorizedException',

  // The error happens when the supplied username/email does not exist in the Cognito user pool
  userNotFoundException: 'UserNotFoundException',

  // The error happens when the user did not enter a required parameter username/email and password
  invalidParameterException: 'InvalidParameterException',

  // The error happens when the user did not enter a password that meets the complexity requirements
  invalidPasswordException: 'InvalidPasswordException',

  // This error happens when a user enters an expired code during password reset.
  expiredCodeException: 'ExpiredCodeException',

  // This error happens when a user enters an invalid/old code during password reset.
  invalidCodeException: 'CodeMismatchException',

  // This error happens when a user clicks forgot password/resend code link more than 5 times in an hour
  limitExceededException: 'LimitExceededException'
};
